export const VocabStatusDisplay = {
    'no_active_medication' : ['No hay tratamientos activos.', 'No active medication.'],
    'active_medication' : ['Tratamientos activos.', 'Active medication.'],
    'medication': ['Tratamientos', 'Medication'],
  }
